import dateFormat from 'dateformat'

export const formatEndDate = (utcDate: any) => {
  const dateObj = new Date(utcDate)
  return dateFormat(dateObj, 'mmmm dS, yyyy')
}

export const formatEndDateTime = (utcDate: any) => {
  const dateObj = new Date(utcDate)
  return dateFormat(dateObj, 'h:MM TT')
}

export const formatPickupDate = (utcDate: any) => {
  const dateObj = new Date(utcDate)
  return `${dateFormat(dateObj, 'dddd, ')} ${dateFormat(
    dateObj,
    'paddedShortDate'
  )} `
}
